module.exports = __webpack_public_path__ + "static/media/nextIcon.2a229115.svg";